const separationFundsReportTypes = Object.freeze({
  SeparationFunds: 1,
  FundsAvailability: 2,
  Certification: 3,
});

export default separationFundsReportTypes;
